import { render, staticRenderFns } from "./TheSectionDetail.vue?vue&type=template&id=da6c49b0&scoped=true"
import script from "./TheSectionDetail.vue?vue&type=script&lang=js"
export * from "./TheSectionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6c49b0",
  null
  
)

export default component.exports